import {Injectable} from '@angular/core';
import {Capacitor} from '@capacitor/core';
import {DeviceService} from '@mydocma/core/src/lib/device';
import {isIosDevice} from '@docma-mm-core/utils/utils';
import {MmIosKeyboardScrollLockService} from './ios/keyboard-scroll-lock.service';
import {MmAndroidKeyboardDialogFitService} from './android/keyboard-dialog-fit.service';

@Injectable({providedIn: 'root'})
export class MmMobileKeyboardService {

  constructor(
    private readonly deviceService: DeviceService,
    private readonly iosScrollLock: MmIosKeyboardScrollLockService,
    private readonly androidDialogFit: MmAndroidKeyboardDialogFitService,
  ) {}

  init(): void {
    if (typeof document !== 'undefined' && this.deviceService.isTablet()) {
      document.documentElement.classList.add('mm-tablet-keyboard');
    }
    if (Capacitor.isNativePlatform() && !isIosDevice()) {
      this.androidDialogFit.start();
    }
    this.iosScrollLock.init();
  }
}
